import { Injectable, inject } from '@angular/core';

import { Page } from '../../client-config/page.client-config';
import { ProductService } from '../../products/product.service';
import { ViewTransitionUtils } from '../../view-transition/view-transition.utils';
import { DslCacheService } from '../dsl-cache.service';
import { DslRecorderService } from '../dsl-recorder.service';
import { DslRecordable, DslValuesProvider } from '../dsl.models';

@Injectable()
export class AppDslValuesProvider implements DslValuesProvider {
    readonly dslCacheService = inject(DslCacheService);
    private readonly dslRecorderService = inject(DslRecorderService);
    private readonly productService = inject(ProductService);
    private readonly page = inject(Page);

    readonly #viewTransitionUtils = inject(ViewTransitionUtils);

    constructor() {
        this.productService.productChanged
            .pipe(this.#viewTransitionUtils.deferUntilTransitionReady())
            .subscribe(() => this.dslCacheService.invalidate(['productChanged']));
    }

    getProviders(): { [provider: string]: DslRecordable } {
        return {
            App: this.dslRecorderService
                .createRecordable('app')
                .createProperty({ name: 'Theme', get: () => this.page.theme })
                .createProperty({
                    name: 'Product',
                    get: () => (this.productService.current.name === 'host' ? this.page.product : this.productService.current.name), // use only this.productService.current.name after single domain migration is finished
                    deps: 'productChanged',
                })
                .createProperty({ name: 'IsSingleDomainApp', get: () => this.productService.isSingleDomainApp }),
        };
    }
}
